import { useReduxState } from 'hooks';
import { Dropdown } from 'components/common/dropdown';
import { Icon } from 'components/common/icons';

interface Props {
  updateData: (props: { type?: string }) => void;
}

const FollowSearchType = ({ updateData }: Props) => {
  const {
    messages,
    pageState: { type }
  } = useReduxState();

  const handleTypeChange = (event) => {
    const type = event.target.getAttribute('data-type');
    updateData({ type });
  };

  const types = {
    all: messages.commonAll,
    local: messages.analyticsSearchTypeLocal,
    wikipedia: messages.analyticsSearchTypeWikipedia,
    translate: messages.analyticsSearchTypeTranslate
  };

  return (
    <div className="search-analytics-type">
      <Dropdown
        category="lighter"
        showArrow={true}
        title={types[type || 'all']}
      >
        {Object.keys(types).map((key, i) => (
          <button
            key={i}
            data-type={key}
            onClick={handleTypeChange}
            style={{ position: 'relative' }}
          >
            {types[key]}
            {key === (type || 'all') ? (
              <Icon
                icon="check"
                style={{
                  fontSize: '1rem',
                  position: 'absolute',
                  right: '12px',
                  top: '11px'
                }}
              />
            ) : null}
          </button>
        ))}
      </Dropdown>

      <style jsx>{`
        .search-analytics-type {
          display: inline-block;
        }
      `}</style>
    </div>
  );
};

export default FollowSearchType;
